import React, { Component } from "react";
import { connect } from "react-redux";
import { Container, Row, Col } from "reactstrap";

import Header from "./Header";
import BinuyMenu from "./Menu";
import Footer from "./Footer";

import ReactGA from "react-ga";

import "./css/fontawesome-free-5.8.1-web/fontawesome.scss";
import classes from "./App.module.scss";

class App extends Component {
  render() {
    ReactGA.initialize("UA-143329197-1");
    return (
      <div className={classes.App}>
        <Header />
        <Container className={classes.bodyContainer}>
          <Row>
            <Col>
              <BinuyMenu />
            </Col>
          </Row>
        </Container>
        <Footer />
      </div>
    );
  }
}

export default connect(null, null)(App);
